import Crud from '../components/CategoryVideo/Crud'
import Add from '../components/CategoryVideo/Add'
import Edit from '../components/CategoryVideo/Edit'

let routes = {
    path: '/categoryVideo',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/categoryVideo',
            component: Crud
        },
        {
            path: '/categoryVideo/add',
            component: Add
        },
        {
            path: '/categoryVideo/edit/:id',
            component: Edit
        }
    ]
};

export default routes


// WEBPACK FOOTER //
// ./src/router/categoryVideo.js